import React, { useState } from 'react';
import { setOnboardingComplete } from '../utils/storage';
import { useTranslation } from 'react-i18next';
import Icon from '../components/Icon';
import './styles/OnboardingScreen.css';

const icons = ['globe', 'book', 'pen', 'chart'];
const colors = ['var(--color-vocab)', 'var(--color-writing)', 'var(--color-speaking)', 'var(--color-progress)'];

const OnboardingScreen = ({ onComplete }) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);

  const pages = [0, 1, 2, 3].map((i) => ({
    title: t(`onboarding_title_${i}`),
    description: t(`onboarding_desc_${i}`),
    icon: icons[i],
    color: colors[i],
  }));

  const handleFinish = () => {
    setOnboardingComplete();
    onComplete();
  };

  const isLastPage = currentPage === pages.length - 1;
  const isFirstPage = currentPage === 0;

  return (
    <div className="onboarding-overlay" role="dialog" aria-modal="true" aria-label="Welcome walkthrough">
      <div className="onboarding-card">
        <div className="onboarding-content">
          <div className="onboarding-icon-wrap" style={{ color: pages[currentPage].color }}>
            <Icon name={pages[currentPage].icon} size={64} strokeWidth={1.5} />
          </div>
          <h2 className="onboarding-title">{pages[currentPage].title}</h2>
          <p className="onboarding-description">{pages[currentPage].description}</p>
        </div>

        <div className="onboarding-dots" role="tablist" aria-label="Page indicator">
          {pages.map((_, index) => (
            <button
              key={index}
              role="tab"
              aria-selected={index === currentPage}
              aria-label={`Page ${index + 1} of ${pages.length}`}
              className={`onboarding-dot${index === currentPage ? ' active' : ''}`}
              onClick={() => setCurrentPage(index)}
            />
          ))}
        </div>

        <div className="onboarding-buttons">
          {!isFirstPage && (
            <button className="onboarding-back" onClick={() => setCurrentPage(currentPage - 1)}>
              {t('back')}
            </button>
          )}
          {!isLastPage && isFirstPage && (
            <button className="onboarding-skip" onClick={handleFinish}>
              {t('skip')}
            </button>
          )}
          <button
            className="onboarding-next"
            onClick={isLastPage ? handleFinish : () => setCurrentPage(currentPage + 1)}
          >
            {isLastPage ? t('letsGo') : t('next')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingScreen;
